import {Component} from '@angular/core';
import {BaseModalComponent} from "../../../views/modal/base_modal.component";
import {User} from "app/models/support.model";
import {HelperService} from "../../../lib/helper.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {DataProvider2} from "../../../provider/data2.provider";

interface BanReregResponse {
	success: boolean;
	message: string;
	bannedCount: number;
	totalCount: number;
	errors?: Array<{email: string, error: string}>;
}

@Component({
	template: `
		<base-modal
			[title]="title"
			(onOk)="ok()"
		>
			<table class="table">
				<thead>
					<tr>
						<th>
							{{ 'Дата регистрации' | translate }}
						</th>

						<th>
							{{ 'Пользователь' | translate }}
						</th>
					</tr>
				</thead>
				
				<tbody>
					<tr *ngFor="let user of users" [id]="user._id">
						<td>
							{{ user.created | dateTimeFormat }}
						</td>

						<td>
							<gotosupport
								[queryParams]="{email: user.email, username: user.username}"
							>
								{{ user.email || user.username }}
							</gotosupport>
							
							<span
								class="badge badge-pill badge-secondary"
								*ngIf="currentUser._id === user._id"
							>
								Текущий пользотавель
							</span>
						</td>
					</tr>
				</tbody>
			</table>
			
			<div class="text-center mt-3">
				<button
					type="button"
					class="btn btn-danger"
					(click)="blockAllRereg()"
					[disabled]="isBlocking"
				>
					<i class="fa fa-ban" *ngIf="!isBlocking"></i>
					<i class="fa fa-spinner fa-spin" *ngIf="isBlocking"></i>
					{{ isBlocking ? 'Блокировка...' : 'Заблокировать все перереги' }}
				</button>
			</div>
		</base-modal>
	`
})
export class UserReRegInfoModalComponent extends BaseModalComponent {
	currentUser: User;
	users: User[] = [];
	isBlocking: boolean = false;
	
	constructor(
		public activeModal: NgbActiveModal,
		public helper: HelperService,
		private dataProvider: DataProvider2
	) {
		super(activeModal);
	}
	
	ok() {
		this.activeModal.close();
	}
	
	async blockAllRereg() {
		if (this.isBlocking) {
			return;
		}
		
		// Показываем confirm окно
		const confirmMessage = `Вы уверены, что хотите заблокировать все ${this.users.length} перерегистрации пользователя ${this.currentUser.email || this.currentUser.username}?`;
		const isConfirmed = confirm(confirmMessage);
		
		if (!isConfirmed) {
			return;
		}
		
		this.isBlocking = true;
		
		try {
			// Вызываем бекенд для блокировки всех перерег
			const result = await this.dataProvider.post('/user/ban_rereg', {
				userId: this.currentUser._id
			}).toPromise() as BanReregResponse;
			
			// Показываем результат
			if (result.success) {
				alert(`Успешно заблокировано ${result.bannedCount} пользователей из ${result.totalCount}`);
			} else {
				alert('Ошибка при блокировке перерег: ' + result.message);
			}
			
			// Закрываем модальное окно после успешной блокировки
			this.activeModal.close();
		} catch (error) {
			console.error('Ошибка при блокировке перерег:', error);
			alert('Ошибка при блокировке перерег. Попробуйте еще раз.');
		} finally {
			this.isBlocking = false;
		}
	}
}
